export default __webpack_public_path__ + "static/media/card-background-rose.cc5836c5.svg";